/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Country controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { SetCountryFavoriteRequest, RequestOptions, GetCountrySelectResponse, GetCountryDetailsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CountryService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    setCountryFavorite(isoCode: string, setCountryFavoriteRequest: SetCountryFavoriteRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    setCountryFavorite(isoCode: string, setCountryFavoriteRequest: SetCountryFavoriteRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    setCountryFavorite(isoCode: string, setCountryFavoriteRequest: SetCountryFavoriteRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    setCountryFavorite(isoCode: string, setCountryFavoriteRequest: SetCountryFavoriteRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Country/${isoCode}/Favorite`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, setCountryFavoriteRequest, requestOptions);
    }

    getCountrySelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCountrySelectResponse>;
    getCountrySelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCountrySelectResponse>>;
    getCountrySelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCountrySelectResponse>>;
    getCountrySelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Country/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCountryDetails(isoCode: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCountryDetailsResponse>;
    getCountryDetails(isoCode: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCountryDetailsResponse>>;
    getCountryDetails(isoCode: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCountryDetailsResponse>>;
    getCountryDetails(isoCode: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Country/${isoCode}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
